import { ReactNode } from 'react'
import { useField } from 'formik'
import {
  DayRangePicker,
  DayRangePickerProps,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@ritualco/jutsu'

export type FormikDayRangePickerProps = {
  label?: ReactNode
  name: string
  range: number
  isRequired?: boolean
} & Partial<DayRangePickerProps>

export const FormikDayRangePicker = ({
  label,
  isRequired = false,
  ...props
}: FormikDayRangePickerProps) => {
  const [field, { error, touched }, { setValue }] = useField(props.name)
  return (
    <FormControl
      id={props.name}
      isInvalid={!!error && touched}
      isRequired={isRequired}
    >
      {label && <FormLabel>{label}</FormLabel>}
      <DayRangePicker
        {...field}
        onChange={value => setValue(value)}
        {...props}
        range={props.range}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}
